<template>
  <lcontainer class="py-12 px-12">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <div v-if="summary.length" class="flex flex-wrap">
      <div class="w-full md:w-2/3">
        <div v-for="(que, index) in summary" class="mb-12" :key="index">
          <div class="flex justify-between">
            <span class="font-2xl font-bold mb-2 tenant-main-color"
              >Question {{ index + 1 }}</span
            >
          </div>
          <div>
            <p class="">{{ que.question }}</p>
          </div>
          <div v-if="dataIsEmpty(que.answers_with_option)">
            <main
              class="mt-4"
              v-for="(answer, i) in que.answers_without_option"
              :key="i"
            >
              <p class="mb-1">{{ answer }}</p>
              <hr />
            </main>
          </div>
          <div v-else>
            <lCharts
              class="w-full md:w-2/3"
              :name="Object.keys(que.answers_with_option)"
              :value="Object.values(que.answers_with_option)"
              :height="size.height"
              width="size.width"
            />
          </div>
        </div>
      </div>
      <div class="mb-12 w-full md:w-1/3 px-2">
        <p>Users</p>
        <lSurveyUser
          v-for="user in users"
          :key="user.id"
          :user="user.user"
        ></lSurveyUser>
      </div>
    </div>
    <div class="text-center text-2xl font-semibold text-black" v-else>
      <lEmpty message="No Submissions yet" />
    </div>
  </lcontainer>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import isEmpty from "lodash.isempty";
export default {
  computed: {
    size() {
      return { width: 300, height: 300 };
    },
  },
  data() {
    return {
      form: {},
      errors: [],
      summary: [],
      users: null,
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/surveys",
          text: "All Surveys",
        },
        {
          disabled: true,
          to: "#",
          text: "Survey Summary",
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions([
      "tenantUpdateSurvey",
      "tenantRemoveSurveyQuestion",
      "tenantSingleSurveySummary",
      "tenantSingleSurvey",
      "tenantSingleSurveyUsers",
    ]),
    dataIsEmpty(data) {
      return isEmpty(data);
    },
  },
  async created() {
    this.updateLoader(true);
    let surveys = await this.tenantSingleSurveySummary({
      id: this.$route.params.survey_id,
    });

    this.users = await this.tenantSingleSurveyUsers({
      id: this.$route.params.survey_id,
    });

    this.updateLoader(false);
    let data = [];
    for (let i = 0; i < surveys.length; i++) {
      let value = Object.values(surveys[i])[0];
      let question = Object.keys(surveys[i])[0];
      data.push({ question, ...value });
    }
    this.summary = data;
  },
  components: {
    lcontainer: () => import("@/components/general/container"),
    LmsButton: () => import("@/components/general/button"),
    linput: () => import("@/components/general/input"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    lCharts: () => import("@/components/shared/chart/pie.vue"),
    lSurveyUser: () => import("@/components/forms/survey_user.vue"),
    lEmpty: () => import("@/components/general/Empty.vue"),
  },
};
</script>
<style scoped></style>
